const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getCampaignInfo = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const testCampaign = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}/test`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getCampaignAnalytics = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}/analytics`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const downloadCampaignReport = async (id, type) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/campaigns/${id}/downloadReport?eventType=${type}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response;
};

export const getCampaignCount = async ({ type, offset, limit, isABTest, isDraft, status, search, complianceStatus }) => {
  let qs = `?`;
  if (type) {
    qs += `type=${type}`
  }
  if (complianceStatus) {
    qs += `&complianceStatus=${complianceStatus}`
  }
  if (isABTest) {
    qs += `&isABTest=${isABTest}`
  }
  if (isDraft == true || isDraft == false) {
    qs += `&isDraft=${isDraft}`
  }
  if (!isNaN(offset)) {
    qs += `&offset=${offset}`
  }
  if (!isNaN(limit)) {
    qs += `&limit=${limit}`
  }
  if (status) {
    qs += `&status=${status}`
  }
  if (search) {
    qs += `&search=${search}`
  }
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `personal/campaigns/totalCount${qs}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};



export const getCampaigns = async ({ type, offset, limit, isABTest, isDraft, status, search, complianceStatus }) => {

  let qs = `?`;
  if (type) {
    qs += `type=${type}`
  }
  if (complianceStatus) {
    qs += `&complianceStatus=${complianceStatus}`
  }
  if (isABTest) {
    qs += `&isABTest=${isABTest}`
  }
  if (isDraft == true || isDraft == false) {
    qs += `&isDraft=${isDraft}`
  }
  if (!isNaN(offset)) {
    qs += `&offset=${offset}`
  }
  if (!isNaN(limit)) {
    qs += `&limit=${limit}`
  }
  if (status) {
    qs += `&status=${status}`
  }
  if (search) {
    qs += `&search=${search}`
  }

  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `personal/campaigns${qs}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};



export const postCampaignData = async (data, id) => {
  const response = await axios({
    method: "post",
    url: !id
      ? process.env.REACT_APP_API_BASE_URL + "personal/campaigns"
      : process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const putCampaignData = async (data, id) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const postCampaignPublish = async (id, wordpressFlag) => {
  const response = await axios({
    method: "post",
    url:
      process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}/publish`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data:{wordpressFlag:wordpressFlag}
  });
  return response.data;
};
export const getAdvisorScript = async (id) => {
  const response = await axios({
    method: "get",
    url:
      process.env.REACT_APP_API_BASE_URL + `personal/campaigns/${id}/script`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};




export const postABTestCampaign = async (data) => {
  const response = await axios({
    method: "post",
    url:
      process.env.REACT_APP_API_BASE_URL + `personal/campaigns`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const getCampaignEmails = async () => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + "personal/campaigns/email",
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
}